module.exports = __webpack_public_path__ + "static/img/8.0b063d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/8.png
// module id = wgsV
// module chunks = 0